export const CATEGORIES_FILTER = ['demographics', 'economics'];
export const SUBCATEGORIES_ECONOMICS_FILTER = [
  'inflation',
  'investment',
  'grdp',
  'ses 2022',
  'ses 2024 city',
  'ses 2024 province',
  'ses 2024 national',
  'land value',
];

export const STEP3MULTIPLE = [];
export const STEP3SINGLE = ['land value', 'grdp', 'investment', 'inflation'];
export const HAS4STEP = [];
export const nationalLevelRegion = ['investment', 'inflation'];
export const provinceLevelRegion = ['grdp'];
export const cityLevelRegion = [];
export const districtLevelRegion = [
  'ses 2022',
  'ses 2024 city',
  'ses 2024 province',
  'ses 2024 national',
  'land value',
];
export const levelDataShouldVillage = [
  'ses 2022',
  'ses 2024 city',
  'ses 2024 province',
  'ses 2024 national',
  'land value',
];
export const excludeLandValue = ['min', 'max', 'mean'];
export const percentageValueLegend = ['inflation'];
export const generalCurrencyValueLegend = ['investment', 'land value'];
export const billionCurrencyValueLegend = ['grdp'];
